import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Visualisation, Toolbar, Chart, FilterBar} from 'wc-visualisation';
import {Table, Icon, Popover, Tooltip} from 'wc-lib';

require('wc-lib/icons/electricity.svg');
require('wc-lib/icons/wind-generation.svg');
require('wc-lib/icons/demand.svg');

@Component({
  template: require('./dispatch-overview-region.html'),
  name: 'dispatch-overview-region',
  components: {
    'vis-visualisation': Visualisation,
    'vis-toolbar': Toolbar,
    'wc-icon': Icon,
    'wc-table': Table,
    'vis-chart': Chart,
    'vis-filter-bar': FilterBar,
    'wc-popover': Popover,
    'wc-tooltip': Tooltip
  }
})
export class NemDispatchOverviewRegion extends Vue {
  @Prop()
  region: any;

  get regionTitle() {
    return this.region ? this.region.regionId.replace('1', '') : '';
  }

  get totalGeneration() {
    if (this.region)
      return this.region.semiScheduledGeneration + this.region.scheduledGeneration;
  }

  get totalDemandPercentage() {
    if (this.region) {
      if (this.region.totalDemand > 0)
      {
        const max = Math.max(this.totalGeneration, this.region.totalDemand);
        return this.region.totalDemand / max;
      }
      return 0.001;
    }
  }

  get scheduledGenerationPercentage() {
    if (this.region) {
      const max = Math.max(this.totalGeneration, this.region.totalDemand);
      return this.region.scheduledGeneration / max;
    }
  }

  get semiScheduledGenerationPercentage() {
    if (this.region) {
      const max = Math.max(this.totalGeneration, this.region.totalDemand);
      return this.region.semiScheduledGeneration / max;
    }
  }

  get isPriceFirm(): boolean {
    return this.region.priceStatus === 'FIRM';
  }

  get isMarketScaled(): boolean {
    return (this.region.apcFlag & 16) === 16;
  }

  get isMarketSuspended(): boolean {
    return this.region.marketSuspendedFlag !== 0;
  }
}



// WEBPACK FOOTER //
// src/views/electricity/nem/dispatch-overview/dispatch-overview-region.ts